import {Component, Input, OnInit} from '@angular/core';
import {TabOrderStatus} from '../../../core/models/order.model';
import { ActivatedRoute } from '@angular/router';
import { RestaurantStore } from '../../../core/stores/restaurant.store';
import { take } from 'rxjs/operators';
import { MenuItem } from '../../../core/models/cart-item.model';
import { CatalogObject } from '../../../core/models/payment-item.model';

@Component({
  selector: 'app-tab-order-status',
  templateUrl: './tab-order-status.component.html',
  styleUrls: ['./tab-order-status.component.scss']
})
export class TabOrderStatusComponent implements OnInit {
  @Input() public tabOrdersStatus: TabOrderStatus;
  @Input() public first = false

  public kyooFee = null
  serviceChargeName = null;

  public isAllModifiersHidden(modifiers: CatalogObject[]): boolean {
    return modifiers.every(modifier => modifier.hiddenFromCustomer);
  }

  constructor(
    private route: ActivatedRoute,
    private restaurantStore: RestaurantStore
  ) { }

  ngOnInit() {
    this.route.params.pipe(take(1)).subscribe((data) => {
      this.restaurantStore.getRestaurantById(data.locationId).pipe(take(1)).subscribe((restaurant) => {
        this.serviceChargeName = restaurant?.serviceChargeName;
        this.kyooFee = restaurant?.kyooFee
      });
    });
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
    let fee = 0;
    if(this.kyooFee && this.kyooFee > 0 && this.first){
      fee = (this.kyooFee/quantity)/100
    }
      return (+(Number(price)+fee) / 100 * quantity).toFixed(2);
  }

}
